<template>
  <div>
    <!--<active-jobs />-->
    <b-tabs content-class="mt-1">
      <!-- This tabs content will always be mounted -->
      <b-tab title="Active Jobs">
        <b-row>
          <b-col cols="12">
            <active-jobs />
          </b-col>
        </b-row>
      </b-tab>

      <!-- This tabs content will not be mounted until the tab is shown -->
      <!-- and will be un-mounted when hidden -->
      <b-tab
        title="Closed Jobs"
        id="closed-jobs"
        lazy
      >
        <b-row>
          <b-col cols="12">
            <closed-jobs />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab
        title="Archived Jobs"
        lazy
      >
        <b-row>
          <b-col cols="12">
            <draft-jobs />
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs, BTab, BRow, BCol,
} from 'bootstrap-vue'
import ActiveJobs from './ActiveJobs.vue'
import ClosedJobs from './ClosedJobs.vue'
import DraftJobs from './DraftJobs.vue'

export default {
  components: {
    ActiveJobs,
    ClosedJobs,
    DraftJobs,
    BTabs,
    BTab,
    // BAlert,
    BRow,
    BCol,
  },
  data() {
    return {
    //  id: '',
      jobData: '',
    }
  },
  created() {
    // Jobs list data is loaded by child tab components (ActiveJobs, ClosedJobs, DraftJobs).
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
